import { createFileRoute } from "@tanstack/react-router";

import { RoleGuard } from "@/components/shared/guards/role-guard";
import { TenantDetailPage } from "@/features/platform-admin";

function TenantDetailRoute() {
  return (
    <RoleGuard allowedRoles={["platform_admin"]}>
      <TenantDetailPage />
    </RoleGuard>
  );
}

export const Route = createFileRoute("/platform-admin/$tenantId")({
  component: TenantDetailRoute,
});
